import { Modals } from '../../../shared/modals/Modals';
import React from 'react';
import { iDataUpdateModalProps } from '../../../model/app/Application';
import { useTranslation } from 'react-i18next';
export const IrrelevanceUpdateModal = ({
  selectedData,
  changeHandler,
  updateData,
}: iDataUpdateModalProps) => {
  const { t } = useTranslation();
  return (
    <Modals
      modalId="modaldemo1"
      title={`${t('Irrelevance.irrelevance')} - ID: ${selectedData?.id}`}
      body={
        <div className="form-group mb-0">
          <label htmlFor="reason">{t('Irrelevance.reason')}</label>
          <input
            type="text"
            className="form-control updateModalField"
            name="reason"
            key={selectedData?.reason}
            defaultValue={selectedData?.reason}
            onBlur={changeHandler}
            placeholder="Enter reason"
          />
        </div>
      }
      updateChanges={updateData!}
    />
  );
};
